// extracted by mini-css-extract-plugin
export default {"nextBtn":"NextButton_nextBtn__Nx1Yq","inactive":"NextButton_inactive__3xXn+"};